/**
 * TODO: Remove debugging logs in this file.
 */

import { ApiClient } from '../api-client';

import {
  IValidateLoginOtpPayload,
  IValidateLoginOtpResponse,
  IValidateLoginTypePayload,
  IValidateLoginTypeResponse,
} from './types';
import { validateLoginOtpUrl, validateLoginTypeUrl } from './urls';

/**
 * This is provides the user experience for the Asset Tracker tool
 *
 */
export class AssetTrackerApiClient extends ApiClient {
  private static classInstance?: AssetTrackerApiClient;

  private constructor() {
    super({
      baseURL: process.env.NEXT_PUBLIC_BASE_HOST_URL || '',
    });
  }

  /**
   * Applying the dreaded singleton pattern here to reuse the axios instance.
   */
  public static getClientInstance = () => {
    if (!this.classInstance) {
      this.classInstance = new AssetTrackerApiClient();
    }

    return this.classInstance;
  };

  /**
   * API call to validate the login type for the user.
   */
  public validateLoginType = async (payload: IValidateLoginTypePayload) => {
    const response = await this.post<IValidateLoginTypeResponse>(
      validateLoginTypeUrl(),
      payload,
      {
        requiresAuth: false,
        baseURL: process.env.NEXT_PUBLIC_BASE_HOST_URL || '',
      }
    );

    if (!response.success) throw response;

    return response.data.data;
  };

  /**
   * API call to validate the login otp for the user.
   */
  public validateLoginOtp = async (payload: IValidateLoginOtpPayload) => {
    const response = await this.post<IValidateLoginOtpResponse>(
      validateLoginOtpUrl(),
      payload,
      {
        requiresAuth: false,
        baseURL: process.env.NEXT_PUBLIC_BASE_HOST_URL || '',
      }
    );

    if (!response.success) throw response;

    return response.data.data;
  };
}

/**
 * This creates a new instance of the class. is th base Axios API client Class
 * wrapper for the Asset Tracker related requests.
 */
export const ASSET_TRACKER_SERVICE_API =
  AssetTrackerApiClient.getClientInstance();
